angular.module('MW.InsDashboard.SocialReachService', [
    'MW.DashboardLegacy.Constants',
    'MW.Framework.CoreCompanyService'
])
.factory('SocialReachService', [
    '$http',
    'SOCIAL_REACH_WIDGET_URL',
    'CoreCompanyService',
    function ($http,
        SOCIAL_REACH_WIDGET_URL,
        CoreCompanyService) {
        'use strict';

        var socialReachService = {};

        /**
         * Responsible for getting the social reach data
         * @returns {*} social reach data
         */
        socialReachService.getSocialReach = function getSocialReach(searchId, dateStart, dateEnd, granularity, timezone, filters) {
            var GET_SOCIAL_REACH_URL = SOCIAL_REACH_WIDGET_URL + '/v1',
                socialReachPayload = {
                    searchId: searchId,
                    dateStart: dateStart,
                    dateEnd: dateEnd,
                    filters: filters,
                    granularity: granularity,
                    timeZone: timezone
                };
            
            return CoreCompanyService.getCurrent(true).then(function handleCompanyResponse(company) {
                socialReachPayload.companyId = company._id;
                return $http.post(GET_SOCIAL_REACH_URL, socialReachPayload);
            });
        }

        return socialReachService;
    }
]);